import isEmpty from 'lodash/isEmpty';
import { MILLIS_IN_DAY } from '../constants/common';
/**
 * Function to check date is valid within a range specified by minDiff and maxDiff
 * @param value Date value to check
 * @param minDateDiff difference of min allowed date from today
 * @param maxDateDiff difference of max allowed date from today
 * @returns string | null
 */
export var validateDate = function (value, minDateDiff, maxDateDiff) {
    var today = Date.now();
    var selectDate = new Date(value).getTime();
    if (maxDateDiff) {
        var allowedMaxDate = today + maxDateDiff * MILLIS_IN_DAY;
        if (selectDate > allowedMaxDate) {
            return "Date cannot be greater than ".concat(new Date(allowedMaxDate).toDateString());
        }
    }
    if (minDateDiff) {
        var allowedMinDate = today + minDateDiff * MILLIS_IN_DAY;
        if (selectDate < allowedMinDate) {
            return "Date cannot be less than ".concat(new Date(allowedMinDate).toDateString());
        }
    }
    return null;
};
/**
 * Function to validate phone number. Includes India validation with 10 digit number
 * @param required required code and phone object
 * @param code phone code to check
 * @param phone phone number to check
 * @returns string | null
 */
export var validatePhoneNumber = function (required, code, phone) {
    if (((required === null || required === void 0 ? void 0 : required.code) && isEmpty(code)) || ((required === null || required === void 0 ? void 0 : required.phone) && isEmpty(phone))) {
        return 'Phone Number is Required';
    }
    if (code === '+91' && (phone === null || phone === void 0 ? void 0 : phone.length) !== 10) {
        return 'Please enter a valid Phone Number';
    }
    return null;
};
//# sourceMappingURL=validations.js.map